export const portfolioLinks = {
    booking: 'https://cal.com/prosamik/30min',
    community: 'https://www.skool.com/zero-to-one-7899/about',
};

// Portfolio artwork lives in the public R2 bucket behind cdn.prosamik.com.
export const portfolioAsset = (name: string) => `https://cdn.prosamik.com/portfolio/${name}`;

export const portfolioSocials = [
    { label: 'GitHub', href: 'https://github.com/prosamik' },
    { label: 'YouTube', href: 'https://youtube.com/@prosamik' },
    { label: 'X', href: 'https://x.com/prosamik' },
    { label: 'LinkedIn', href: 'https://linkedin.com/in/prosamik' },
];
